import React from "react";
import { Paper } from "@mui/material";
import { DataGridPro, DataGridProProps } from "@mui/x-data-grid-pro";
import { useIntl } from "react-intl";
import { dataGridStyles } from "./styles";
import { HEADER_HEIGHT, ROW_HEIGHT, ROWS_PER_PAGE } from "../../constants";

interface StyledDataGridProps extends DataGridProProps {
  paperClassName?: string;
  gridClassName?: string;
}

const StyledDataGrid: React.FC<StyledDataGridProps> = ({
  paperClassName,
  gridClassName,
  ...props
}) => {
  const intl = useIntl();
  const { classes } = dataGridStyles();

  return (
    <Paper className={paperClassName ?? classes.paper}>
      <DataGridPro
        className={gridClassName ?? classes.root}
        disableColumnMenu
        columnHeaderHeight={HEADER_HEIGHT}
        rowHeight={ROW_HEIGHT}
        pageSizeOptions={ROWS_PER_PAGE}
        localeText={{
          noRowsLabel: intl.formatMessage({ id: "NO_DATA" }),
        }}
        {...props}
      />
    </Paper>
  );
};

export default StyledDataGrid;
